<script setup lang="ts">
import DropdownArea from './DropdownArea.vue';

const emit = defineEmits<{ select: [lineSpacing: string]; close: [] }>();
</script>

<template>
  <DropdownArea @close="() => emit('close')">
    <template #default>
      <slot></slot>
    </template>
    <template #area="{ close }">
      <div class="area">
        <span
          v-for="value in ['1.00', '1.25', '1.50', '2.00']"
          :key="`line-spacing-${value}`"
          class="select-item"
          @click="
            () => {
              emit('select', value);
              close();
            }
          "
        >
          {{ value }}
        </span>
      </div>
    </template>
  </DropdownArea>
</template>

<style scoped>
.area {
  font-size: var(--nxt-font-size-md);
  display: flex;
  flex-direction: column;
  gap: 0.125em;
  width: fit-content;
}
.select-item {
  cursor: pointer;
  font-weight: var(--nxt-font-weight-medium);
  padding: 0.125em;
  border-radius: var(--nxt-radius-sm);
  color: var(--nxt-menu-item-fg);

  &:hover {
    /* Match NxSelectInput's highlighted option row exactly (bg + fg). */
    background-color: var(--nxt-menu-item-bg-active);
    color: var(--nxt-menu-item-fg);
  }
}
</style>
